import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

/**
 * Upload notice attachment or signature
 * @param {File} file
 * @param {string} userId
 * @returns {Promise<string>}
 */
export const uploadNoticeFileToStorage = async (file, userId) => {
  if (!file) {
    throw new Error("Invalid file for upload.");
  }

  if (!userId) {
    throw new Error("Invalid userId.");
  }

  try {
    const timestamp = Date.now();
    const filePath = `noticefiles/${userId}/${timestamp}_${file.name}`;
    const fileRef = ref(storage, filePath);
    await uploadBytes(fileRef, file);
    const downloadURL = await getDownloadURL(fileRef);
    return downloadURL;
  } catch (error) {
    console.error("Error uploading notice file:", error);
    throw new Error("Failed to upload notice file.");
  }
};